'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class IndexTableBreadcrumbs extends Component {
  constructor(...args) {
    super(...args);
    this.renderHome = () => {
      const {
        selectedFolder,
        setSelectedFolder
      } = this.props;
      const home = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "salesContentIndexUI.tableNavigation.breadcrumbs.home"
      });
      if (selectedFolder) {
        return /*#__PURE__*/_jsx(Link, {
          "data-selenium-test": "back-to-index-breadcrumb",
          onClick: () => setSelectedFolder(),
          children: home
        });
      }
      return /*#__PURE__*/_jsx("span", {
        children: home
      });
    };
    this.renderFolder = () => {
      const {
        selectedFolder
      } = this.props;
      return /*#__PURE__*/_jsx("span", {
        children: selectedFolder.name
      });
    };
  }
  render() {
    const {
      selectedFolder
    } = this.props;
    if (!selectedFolder) {
      return null;
    }
    return /*#__PURE__*/_jsxs(Breadcrumbs, {
      flush: true,
      singleBreadcrumbIsBackLink: false,
      marginBlockEnd: "200",
      marginBlockStart: "0",
      children: [this.renderHome(), this.renderFolder()]
    });
  }
}
IndexTableBreadcrumbs.propTypes = {
  selectedFolder: PropTypes.instanceOf(SearchResultRecord),
  setSelectedFolder: PropTypes.func.isRequired
};